import { localization } from '~/shared/constants';
import type { Frequency } from '~/shared/types/Frequency';

export const frequencies: Frequency[] = [
  {
    Message: { id: 'everyCatalogue', defaultMessage: localization.everyCatalogue },
    Value: 1,
  },
  {
    Message: {
      id: 'everySecondCatalogue',
      defaultMessage: localization.everySecondCatalogue,
    },
    Value: 2,
  },
  {
    Message: {
      id: 'everyThirdCatalogue',
      defaultMessage: localization.everyThirdCatalogue,
    },
    Value: 3,
  },
];
